import { useCallback, useEffect, useState } from "react";
import { getCostUploadHistory } from "../../API/costUploadHistoryApi";
//import config from "../../../config";

export const useUploadHistory = () => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
   

    const fetchUploadHistory = useCallback(async () => {
        try{

            // console.log("page fetchUploadHistory", page)
           
            const data = await getCostUploadHistory();
            setUploadHistory(data || []);
            // setTotalPages(data.totalPages || config.amountPages);
            // setTotalPages(29);
        } catch (error) {
            console.error("Error fetching upload history:", error); 
        } finally {
            setLoading(false);
        }

    }, []);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

    return {
        fetchUploadHistory,
        uploadHistory,
        page,
        setPage,
        loading
    };
};
